module.exports = __webpack_public_path__ + "static/img/icon_thaiqr.2ddbf155.png";